<div class="create-account-pj">
  @if (saving()) {
    <div class="create-account-pj__loading">
      <div class="create-account-pj__loading-card">
        <aprova-loading-bar title="Salvando o cadastro..." />
      </div>
    </div>
  } @else {
    @if (account(); as account) {
      <div class="create-account-pj__content">
        <div class="registration-completion__header">
          <h1 class="create-account-pj__title" data-testid="registrationCompletionTitle">Complete seu cadastro</h1>
          <p class="registration-completion__subtitle">
            Para acessar, informe o endereço e aceite os termos de uso.
          </p>
        </div>

        <dl class="registration-completion__identity" data-testid="registrationCompletionIdentity">
          <div>
            <dt>{{ isCompany ? 'Razão social' : 'Nome' }}</dt>
            <dd>{{ account.name }}</dd>
          </div>
          <div>
            <dt>{{ isCompany ? 'CNPJ' : 'CPF' }}</dt>
            <dd>{{ account.userMetadata?.cpf ?? '' | mask: (isCompany ? 'AA.AAA.AAA/AAAA-00' : '000.000.000-00') }}</dd>
          </div>
          <div>
            <dt>E-mail</dt>
            <dd>{{ account.email }}</dd>
          </div>
        </dl>

        <aprova-input
          label="Telefone ou celular"
          dataTestid="registrationCompletionInputPhone"
          [control]="phoneNumber"
          [required]="true"
          mask="(00) 0000-0000||(00) 00000-0000"
          [errorMessages]="{
            required: 'Por favor preencha o campo telefone.',
            pattern: 'Por favor, digite um telefone válido.'
          }"
        />

        <app-address-form [hideRecaptcha]="true" [isLastStep]="true" (setStepValidation)="addressValid.set($event)" />

        <div class="create-account-pj__actions">
          <button
            type="button"
            class="create-account-pj__btn create-account-pj__btn--secondary"
            data-testid="registrationCompletionButtonBack"
            (click)="backToLogin()"
          >
            Voltar
          </button>
          <button
            type="button"
            class="create-account-pj__btn create-account-pj__btn--primary"
            data-testid="registrationCompletionButtonSubmit"
            [disabled]="!addressValid() || phoneNumber.invalid"
            (click)="submit()"
          >
            Concluir e entrar
          </button>
        </div>
      </div>
    }
  }
</div>
